// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTableDataResponseContent
 */
export interface GetTableDataResponseContent {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTableDataResponseContent
     */
    columns?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetTableDataResponseContent
     */
    nextToken?: string;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof GetTableDataResponseContent
     */
    records: Array<{ [key: string]: string; }>;
}

/**
 * Check if a given object implements the GetTableDataResponseContent interface.
 */
export function instanceOfGetTableDataResponseContent(value: object): value is GetTableDataResponseContent {
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function GetTableDataResponseContentFromJSON(json: any): GetTableDataResponseContent {
    return GetTableDataResponseContentFromJSONTyped(json, false);
}

export function GetTableDataResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTableDataResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'columns': json['columns'] == null ? undefined : json['columns'],
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
        'records': json['records'],
    };
}

export function GetTableDataResponseContentToJSON(json: any): GetTableDataResponseContent {
    return GetTableDataResponseContentToJSONTyped(json, false);
}

export function GetTableDataResponseContentToJSONTyped(value?: GetTableDataResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'columns': value['columns'],
        'nextToken': value['nextToken'],
        'records': value['records'],
    };
}
